<template>
    <div class="joinMain">
        <p class="current">当前位置：<span>企业用户入驻</span></p>
        <div class="join-box">
            
            <div class="ruleFormCode">
                
                <p class="step-title" v-if="!resOk">企业用户信息</p>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" 
                    :label-width="widthNew?'120px':'26%'" class="formName"  v-if="!resOk">
                    <el-form-item label="企业类型" prop="joinType">
                        <el-select v-model="ruleForm.joinType" multiple placeholder="请选择企业类型">
                            <el-option
                                v-for="item in options"
                                :key="item.cate_id"
                                :label="item.cate_name"
                                :value="item.cate_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="企业名称" prop="joinName">
                        <el-input v-model="ruleForm.joinName" placeholder="请填写企业名称"  style=" width: 332px;height: 42px;"></el-input>
                        <!-- <el-autocomplete
                            v-model="ruleForm.joinName"
                            :fetch-suggestions="remoteSearch"
                            placeholder="请填写企业名称"
                            @select="handleSelect"
                            class="first-input"
                            >
                        </el-autocomplete> -->
                    </el-form-item>
                
                    <el-form-item label="信用代码" prop="creditCode">
                        <el-input v-model="ruleForm.creditCode" placeholder="请填写统一社会信用代码"  style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="区县" prop="region">
                        <el-cascader class="InputW"
                            ref="cascader"
                            v-model="ruleForm.region"
                            :options="optionsOptions"
                            :props="props"
                            style=" width: 332px;height: 42px;"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="地址" prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请填写地址"  style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contacts">
                        <el-input v-model="ruleForm.contacts" placeholder="请填写联系人"  style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                    <el-form-item label="电话号码" prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请填写电话号码" style=" width: 332px;height: 42px;"></el-input>
                    </el-form-item>
                   
                   
                    <el-form-item label="资质图片" prop="qualificationImage">
                        <div class="list-card-img">
                            <img width="200px" height="150px" v-for="item in ruleForm.qualificationImage" :key="item.FileUrl" :src="item.FileUrl" alt="">
                            <el-upload
                                ref="upload"
                                :http-request="handleQualificationImage"
                                action="https://qiliangong.oss-cn-shenzhen.aliyuncs.com"
                            >
                                <i class="el-icon-plus borderI" ></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="企业简介" prop="profile">
                        <el-input type="textarea" :rows="4" v-model="ruleForm.profile" placeholder="请填写企业简介(限 500 字以内)" class="InputW"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width: 260px;"  @click="handleJoin">确认并提交</el-button>
                    </el-form-item>
                </el-form>
                
                <div v-if="resOk">
                    <div v-if="joinStatus.audit_status == '100'">
                        <el-result subTitle="审核中">
                            <template slot="icon">
                                <div class="chartI"></div>
                            </template>
                       
                        </el-result>
                    </div>
                    <div  v-if="joinStatus.audit_status == '2'">
                    <!-- <div v-if="joinStatus.audit_status == '100'"> -->
                        <el-result subTitle="审核未通过">
                            <template slot="icon">
                                <div class="chartI"></div>
                            </template>
                           
                            <template slot="extra">
                                <el-button type="primary" @click="resOk = false">重新上传</el-button>
                            </template>
                        </el-result>
                    </div>
                   
                </div>

                
            </div>
        </div>
       
    </div>
</template>

<script>
import axios from 'axios';
export default({
    data(){
        return{
            formData:{},
            resOk: false,
            props: {
                //开启懒加载
                lazy: true,
                lazyLoad: this.typeEconomyGetSelectList,
            },
            optionsOptions: [
                // { value: 1, label: "111",a:'a', children: [{ value: 3, label: "333" ,a:'b'}] },
                // { value: 2, label: "222",a:'c' },
                {id:1,label:'广州市',value: {code: 440100,name: '广州市'}},
                {id:2,label:'东莞市',value: {code: 441900,name: '东莞市'}}
            ],
            host: '',
            options: [],
            dialogImageUrl: '',
            dialogVisible: false,
            results: [],
            ruleForm: {
                joinType: '',
                joinName: '',
                creditCode: '',
                region: '',
                contacts: '',
                phone: '',
                address: '',
                profile: '',
                qualificationImage: []
            },
            rules: {
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                joinType: [
                    {  required: true, message: '请选择企业类型', trigger: 'blur' }
                ],
                joinName: [
                    {  required: true, message: '请填写企业名称', trigger: 'change' }
                ],
                address: [
                    {  required: true, message: '请填写地址', trigger: 'change' }
                ],
                creditCode: [
                    {  required: true, message: '请填写统一社会信用代码', trigger: 'change' }
                ],
                region: [
                    {  required: true, message: '请选择所属区域', trigger: 'change' }
                ],
                contacts: [
                    {  required: true, message: '请填写联系人', trigger: 'change' }
                ],
                
                qualificationImage: [
                    {  required: true, message: '请上传资质图片', trigger: 'change' }
                ],
                profile: [
                    {  required: true, message: '请填写公司简介', trigger: 'change' },
                    {  max: 500, message: '限 500 字以内', trigger: 'blur' }
                ]

               
               
            },

            imgList: [],
            joinStatus: {},
            widthNew: false
        }
    },
    watch: {
        
    },
    methods:{
         // 动态加载地区
        typeEconomyGetSelectList(node, resolve) {
            console.log("999999999999");
            console.log(node);
            const { level, value } = node;
            let params = {
                parent_name: node.label,
                pageSize: 99
            };
            console.log("cces");
           
            this.$store.dispatch('login/listarea',params)
                        .then(res => {
                            console.log("获取地址");
                            console.log(res);

                            if(res.ok){
                                var nodes = res.data.items.map((item) => {
                                    return {
                                        id: item.id,
                                        value: {
                                            code: item.id,
                                            name: item.name
                                        },
                                        label: item.name,
                                        leaf: level >= 1,
                                        parent_id: item.parent_id,
                                        wid: item.wid,
                                        idx: item.idx,
                                    };
                                });
                                console.log("nodes-----------------");
                                console.log(nodes);
                                resolve(nodes);
                            }
                             
                        }).catch(err => {
                            console.log("失败失败");
                            console.log(err);
                        })
        },
        //企业类型
        getListcate(data){
            this.$store.dispatch('join/listcate',data)
                .then(res => {
                    if(res.ok){
                        this.options = res.data
                    }
                })
           
        },
        getUserJoin(){
            let data = {}
            this.$store.dispatch('join/infoByUserId',data)
                .then(res => {
                   
                    this.resOk = res.ok
                    this.joinStatus = res.data
                    // if(res.ok){
                    //     this.ruleForm = {
                    //         joinType: this.joinStatus.cates,
                    //         joinName: this.joinStatus.name,
                    //         creditCode: this.joinStatus.code,
                    //         region: [
                    //             {code: this.joinStatus.city,name: this.joinStatus.city_name},
                    //             {code: this.joinStatus.county,name: this.joinStatus.county_name},
                    //         ],
                    //         contacts: this.joinStatus.contact,
                    //         phone: this.joinStatus.phone,
                    //         address: this.joinStatus.address,
                    //         profile: this.joinStatus.description,
                    //         qualificationImage: JSON.parse(this.joinStatus.file_items)
                    //     }
                    // }
                })
        },
      
      
        handleJoin(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    console.log(this.ruleForm.region);
                    let data = {
                        address: this.ruleForm.address,
                        cates: this.ruleForm.joinType,
                        city: this.ruleForm.region[0].code, 
                        city_name: this.ruleForm.region[0].name,
                        code: this.ruleForm.creditCode,
                        contact: this.ruleForm.contacts,
                        county:  this.ruleForm.region[1].code,
                        county_name: this.ruleForm.region[1].name,
                        description: this.ruleForm.profile,
                        file_items: JSON.stringify(this.ruleForm.qualificationImage),
                        name: this.ruleForm.joinName,
                        phone: this.ruleForm.phone,
                        province:"440000",
                        product_name: '广东省'
                    }

                    console.log(data);
                    this.$store.dispatch('join/joinUser',data)
                        .then(res => {
                            if(res.ok){
                                this.$notify({
                                    title: '提示',
                                    message: res.msg,
                                    type: 'success'
                                })
                                this.getUserJoin()
                            }
                        })
                }
            })
        },
        getUUID(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
            })  
        },
        fileToBlob(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const blob = new Blob([reader.result], { type: file.type });
                    resolve(blob);
                };

                reader.onerror = reject;

                reader.readAsArrayBuffer(file);
            });
        },
        handleTransform(options,val){
            
            console.log("上传的文件")
            console.log(options)
            let data = {}
            this.$store.dispatch('train/policy',data)
                .then(res => {
                    if(res.ok){

                        this.fileToBlob(options.file).then(blob => {
                           
                            console.log('Blob对象:', blob);
                           
                            console.log('ossPolicyX')
                            console.log(res)
                            var info = res.data
                            var key = info.dir + this.getUUID() + options.file.name.substring(options.file.name.lastIndexOf(".")) 
                            
                            console.log('key')
                            console.log(key)
                            let formData = new FormData()

                            formData.append('key', key)
                            formData.append('OSSAccessKeyId', info.accessId)
                            formData.append('policy', info.policy)
                            formData.append('signature', info.signature)
                            formData.append('success_action_status', '200')
                            formData.append('file', options.file)
                            
                            axios({
                                url: info.host,
                                contentType: false,
                                method: 'post',
                                data: formData,
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }).then(res => {
                                const { status } = res
                                if (status === 200) {
                                    var filename = options.file.name
                                    var pictureUrl = info.host + '/' + key;//获得到的url需要将其存数据库中
                                 if(val ==  3){
                                        this.ruleForm.qualificationImage.push({
                                            filename: filename,
                                            lanmu: 'booking',
                                            picurl: pictureUrl,
                                            FileName: filename,
                                            FileUrl: pictureUrl,

                                        })  
                                   }

                                
                                } 
                            })
                     
                        });
						
						
					}
                })
           
        },
        handleQualificationImage(file){
            this.handleTransform(file,3)
        }
        
    },
    mounted(){
        
    },
    
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let data = {
            pageSize: 999,
            parent_cate_value: 'company'
       }
       this.getListcate(data)
       this.getUserJoin()
    }
})
</script>
<style scoped>

@import url(../../../css/join.css);
::v-deep .codeInput{
    width: 170px !important;
}
.borderI{
    text-align: center;
    cursor: pointer;
    width: 200px;
    outline: 0;
    height: 150px;
    line-height: 150px;
    border-radius: 5px;
    border: 1px dashed #999999;
    font-size: 20px;
    color: #999999;
    margin-left: 5px;
}
.ruleFormCode .el-upload-list__item{
    display: none;
}




::v-deep .scrollbar__view {
    width: 333px !important;
}

::v-deep .ruleFormCode .el-cascader .el-input .el-input__inner{
    width: 333px !important;
    position: relative !important;
}
::v-deep .ruleFormCode .el-cascader .el-input .el-icon-arrow-down{
    display: none;
    /* position: absolute !important;
    right: -140px !important; */
}

::v-deep .ruleFormCode .el-input--suffix .el-input__inner {
    width: 333px !important;
    position: relative !important;
    
}

::v-deep .ruleFormCode .el-select .el-input .el-select__caret{
    display: none;
    /* position: absolute !important; */
    /* right: 100px !important; */
}

::v-deep .ruleFormCode .el-autocomplete .el-input{ 
    width: 333px !important;
}

::v-deep .ruleFormCode .el-upload-list__item{
    display: none !important;
}

::v-deep .el-select {
    width: 333px !important;  
}

::v-deep .el-select__tags{
    max-width: 333px !important;
}

@media screen and (max-width: 540px) {
    .joinMain{
        width: 96%;
        padding: 10px 0px;
    }
    .join-box{
        width: 100%;
    }
    .ruleFormCode{
        width: 100%;
    }
    ::v-deep .formName .el-input{
        width: 232px !important;
    }
    .InputW{
        width: 232px;
    }

    ::v-deep .ruleFormCode .codeInput{
        width: 130px !important;
    }
    ::v-deep .codeInput{
        width: 130px !important;
    }
    
    .codeButton{
        height: 42px;
        margin-left: 20px;
        background: #f2f2f2;
    }

    ::v-deep .scrollbar__view {
        width: 232px !important;
    }

    ::v-deep .ruleFormCode .el-cascader .el-input .el-input__inner{
        width: 232px !important;
    }
   
    ::v-deep .ruleFormCode .el-input--suffix .el-input__inner {
        width: 232px !important;
        
    }

  

    ::v-deep .ruleFormCode .el-autocomplete .el-input{ 
        width: 232px !important;
    }


    ::v-deep .el-select {
        width: 232px !important;  
    }
    ::v-deep .ruleFormCode .el-cascader{
        width: 232px !important;
    }
    ::v-deep .el-select__tags{
        max-width: 232px !important;
}

}
</style>